import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./dropDown.css";

const BookingSourceDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "", label: "All", icon: "🌐" },
    { value: "app", label: "App", icon: "📱" },
    { value: "kiosk", label: "Kiosk", icon: "🖥️" },
    { value: "web", label: "Web", icon: "💻" },
    { value: "agent", label: "Agent", icon: "🧑‍💼" },
  ];

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="booking-dropdown-wrapper" style={{ minWidth: "220px"}}>
      <button
        className="dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="dropdown-icon">{selectedOption?.icon}</span>
        <span className="dropdown-label">{selectedOption?.label}</span>
        <ChevronDown
          size={18}
          className={`dropdown-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="dropdown-menu-booking" >
          {options.map((option) => (
            <button
              key={option.value}
              className={`dropdown-option ${
                value === option.value ? "active" : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="option-icon">{option.icon}</span>
              <span className="option-label">{option.label}</span>
              {value === option.value && (
                <span className="checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookingSourceDropdown;